// frontend/src/components/Hero.jsx
import React from "react";
import './Hero.css';
import { useTranslation } from 'react-i18next';


const Hero = ({ heroData }) => {
  const { t } = useTranslation();

  if (!heroData || typeof heroData !== 'object' || Object.keys(heroData).length === 0) {
    return (
      <section className="hero" id="hero">
        <h1>{t('hero.title')}</h1>
        <p>{t('messages.loading')}</p>
      </section>
    );
  }

  // const mainHeroItem = heroData[0]; 

  const listItemsArray = heroData.list_item
    ? heroData.list_item.split(';').map(item => item.trim())
    : [];


  return (
    <section className="hero" id="hero">
      <h1>{(heroData.title)}</h1>


      <p>{heroData.paragraph}</p>

      {/* {heroData.paragraph && (
          heroData.paragraph.split(/\r\n|\r|\n/).map((line, index) => (
              <p key={index}>{line}</p>
          ))
      )}  */}

      {listItemsArray.length > 0 && (
        <ul>
          {listItemsArray.map((item, index) => (
            <li key={index}>{item}</li>
          ))}
        </ul>
      )}
      <a href="#contact" className="btn">{t('hero.contactButton')}</a>
    </section>

  );
};

export default Hero;